import { DataProperty } from 'breeze-client';

export interface ValueNormalizerFactory<T> {
  (property: DataProperty): (value?: T) => unknown;
}

const removeEmptyString = (value?: string) => (value === '' ? undefined : value);
// guard against non-string values (eg a raw array from a server-side JSON collection column mapped as a 'String' breeze property)
const trimString = (value?: string) => (typeof value === 'string' ? value.trim() : value);
const trimAndRemoveEmptyString = (value?: string) => removeEmptyString(trimString(value));
const normalizeStringFactory: ValueNormalizerFactory<string> = (property: DataProperty) =>
  property.isNullable ? trimAndRemoveEmptyString : trimString;

export const breezeNormalizer = {
  Guid: normalizeStringFactory,
  String: normalizeStringFactory
};
